import { Order } from '../../types/common-types';

export const defaultSortField = 'id';
export const defaultSortOrder = Order.asc;
export const defaultPage = 1;
export const defaultRowsPerPage = 50;
export const defaultSearchKey = '';
export const defaultSearchInputValue = '';
export const defaultAdditionalFilters = {};
